module.exports = __webpack_public_path__ + "img/arrow.fw.ec4eb0c4.png";